import axios from "axios";
import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { Link, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import Loader from "../../../Components/Global/Loader";
import DashboardLayouts from "../../../Components/Layout/DashboardLayouts";

import moment from "moment";
import { useAuth } from "../../../Context/AuthContext";
import useAuthentication from "../../../hooks/useAuthentication";

function RevenueDetailsAccountantProfile({ allowedRoles }) {
  const { allowLoading } = useAuthentication(allowedRoles);

  const [loading, setLoading] = useState();
  const { designation } = useAuth();

  const [record, setRecord] = useState(30);

  const [isDownload, setisDownload] = useState(false);
  const [printData, setprintData] = useState([]);
  const [paymentsData, setpaymentsData] = useState([]);
  const [tenantData, settenantData] = useState({});

  const { tenantid } = useParams();

  useEffect(() => {
    const getPaymentStatement = async () => {
      setLoading(true);

      await axios
        .get(`revenue/show/${tenantid}`)
        .then((res) => {
          setpaymentsData(res?.data.rentCollection?.rows);
          settenantData(res?.data.tenantInfo[0]);
        })
        .catch((err) => {})
        .finally(() => {
          setLoading(false);
        });
    };

    getPaymentStatement();
  }, [tenantid]);

  const componentRef = React.useRef(null);

  const onBeforeGetContentResolve = React.useRef(null);

  const [text, setText] = React.useState("old boring text");

  const handleAfterPrint = React.useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = React.useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    // tslint:disable-line no-console
    setLoading(true);

    setisDownload(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoading(false);
        setisDownload(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setLoading, setText]);

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "AwesomeFileName",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  React.useEffect(() => {
    if (
      text === "New, Updated Text!" &&
      typeof onBeforeGetContentResolve.current === "function"
    ) {
      onBeforeGetContentResolve.current();
    }
  }, [onBeforeGetContentResolve.current, text]);

  return (
    <>
      <DashboardLayouts>
        {(loading || allowLoading) && <Loader />}

        <div className="breadcrumb row justify-content-between align-items-center">
          <div className="d-flex align-items-center dashboard-upper-menu col-md-6 col-auto">
            <Link
              to={
                designation === "Owner" || designation === "Partner"
                  ? "/owner/revenue"
                  : `/accountant/revenue`
              }
              // to="/accountant/revenue"
              className="d-flex align-items-center back-link"
            >
              <BsArrowLeft className="me-2 m-0 back-arrow" color="black" />
              <i className="icon-dashboard"></i>
              <h3 className="mb-0 fw-normal">Back to Payment list</h3>
            </Link>
          </div>
        </div>

        <div
          ref={componentRef}
          className={isDownload ? "container m-2 " : "container"}
        >
          <div className="col-md order-1 order-xl-2">
            <ul className="">
              <li className="d-flex align-items-center justify-content-between justify-content-md-start">
                <ul className="building-details-wrapper d-flex flex-wrap w-100 justify-between justify-content-md-start">
                  <li className=" list-info">
                    <span>Tenant Name:</span>
                    <p>{`${tenantData?.first_name} ${tenantData?.last_name} `}</p>
                  </li>
                  <li className=" list-info me-md-5">
                    <span>Contact Information:</span>

                    <p> {tenantData?.phone_number}</p>

                    {/* <p>{buildingData.country_name}</p> */}
                  </li>
                </ul>
              </li>
              <li className="d-flex justify-content-between justify-content-md-start">
                <ul className="building-details-wrapper d-flex flex-wrap w-100 justify-between justify-content-md-start">
                  <li className=" list-info">
                    <span>Building Name:</span>
                    <p> {tenantData?.building_name}</p>
                  </li>
                  <li className=" list-info me-md-5">
                    <span>Unit Name:</span>

                    <p> {tenantData?.unit_name}</p>

                    {/* <p>{buildingData.country_name}</p> */}
                  </li>
                </ul>
              </li>
              <li className="d-flex align-items-center justify-content-between justify-content-md-start">
                <ul className="building-details-wrapper d-flex flex-wrap w-100 justify-between justify-content-md-start">
                  <li className=" list-info">
                    <span>Lease Start Date:</span>
                    <p> {moment(tenantData?.lease_start_date).format("L")}</p>
                    {/* {moment(items.cash_collected_date).format("L")} */}
                  </li>
                  <li className=" list-info me-md-5">
                    <span>Lease End Date:</span>
                    <p> {moment(tenantData?.lease_end_date).format("L")}</p>
                  </li>
                </ul>
              </li>
              <li className="d-flex align-items-center justify-content-between justify-content-md-start">
                <ul className="building-details-wrapper d-flex flex-wrap w-100 justify-between justify-content-md-start">
                  <li className=" list-info">
                    <span>Duration :</span>

                    <p>{record > 90 ? "90+" : record}</p>
                    {/* {moment(items.cash_collected_date).format("L")} */}
                  </li>
                  <li className=" list-info me-md-5">
                    <span>Monthly Rent:</span>
                    <p> {tenantData?.monthly_rent}</p>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          {/* ----- Body Content ---- */}
          <div className="list-data ">
            <h1 className="heading-text mb-4">View All Payment statement</h1>

            <div
              className={
                isDownload
                  ? "d-none"
                  : " data-filters d-flex justify-content-between align-items-center mb-4"
              }
            >
              <div className="page-records d-flex align-items-center">
                <form action="" className="number">
                  <select
                    className="number-box"
                    value={record}
                    name="record"
                    onChange={(event) => {
                      setRecord(event.target.value);
                    }}
                  >
                    <option value="30">30</option>
                    <option value="60">60</option>
                    <option value="90">90</option>
                    <option value="9999999">More than 90</option>
                  </select>
                </form>

                <h3 className="mb-0 ms-2 d-none d-sm-block">Days Records </h3>
              </div>

              <div className="form search-bar1 d-flex justify-content-end ms-3">
                <li className="tex-center">
                  <button
                    onClick={handlePrint}
                    className="btn btn-outline-primary"
                    style={{ backgroundColor: "transparent" }}
                  >
                    Print
                  </button>
                </li>
              </div>
            </div>
          </div>
          <div className="w-100 table-content overflow-auto">
            <table className="w-100">
              <thead>
                <tr>
                  <th>Collected By</th>
                  <th>Transaction Date</th>
                  <th> Transaction Type</th>
                  <th> Amount </th>
                  <th>Transaction No.</th>
                  <th className="tex-center"> Balance</th>
                </tr>
              </thead>

              <tbody>
                {paymentsData?.length > 0 ? (
                  paymentsData?.slice(0, record).map((items, i) => {
                    return (
                      <tr key={i} className={`border-b`}>
                        <td className="">
                          <p> {items.cash_collected_by}</p>
                        </td>

                        <td className="">
                          <p>
                            {" "}
                            {moment(items.cash_collected_date).format(
                              "1/MM/YYYY"
                            )}
                          </p>

                          <p>
                            {" "}
                            {moment(items.cash_collected_date).format("L")}
                          </p>
                        </td>
                        <td className="">
                          {" "}
                          <p>Statement</p> <p>Payment </p>{" "}
                        </td>

                        <td className="">
                          <p>
                            {" "}
                            {Number(items.Collected_Amount) +
                              Number(items.balance)}
                          </p>
                          <p>- {items.Collected_Amount}</p>
                        </td>

                        <td className=""> {items.transaction_id}</td>

                        <td className="text-center"> {items.balance}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="w-100 table-content overflow-auto">
            <table className="w-100">
              <thead>
                <tr>
                  <th>Remaining Balance</th>

                  <th> </th>
                  <th> </th>
                  <th> </th>
                  <th> </th>
                  <th></th>
                  <th className="text-center">
                    {paymentsData?.length !== 0
                      ? paymentsData[paymentsData?.length - 1]?.balance
                      : 0}{" "}
                  </th>
                </tr>
              </thead>
              {/* <tbody>

                        <tr>
                            <td className="">07/01/2022 07/01/2022</td>
                            <td className="">21000</td>
                            <td className="">Payment Statement</td>
                        </tr>
                    </tbody> */}
            </table>
          </div>
        </div>
      </DashboardLayouts>
    </>
  );
}

export default RevenueDetailsAccountantProfile;
